import { styled } from 'styled-components';

// Dashed lines separating messages from different days
export const Separator = styled.hr`
  border: var(--border-pale);
  height: 1px;
  margin: 0;
`;
